module.exports = __webpack_public_path__ + "54f5df22f7712c6dcc36233bbd63a1e2.jpg";